import { render, staticRenderFns } from "./CustomerCurrency.vue?vue&type=template&id=4640301a&"
import script from "./CustomerCurrency.vue?vue&type=script&lang=js&"
export * from "./CustomerCurrency.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCurrency.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports